import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import {Pessoa, PessoaImagem} from "./pessoa.model";
import { apiName, pessoaImageApiName } from "./data.service";

@Injectable()
export class PessoaApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Pessoa, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Pessoa, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        this._restService.onGetPostCustom(apiName + '/populado', {}, done);//busca pessoas populado com funcionarios
    }

    onGetAllActive(done: any) {
        var filter: any = {"where":{"ativo":true},"order":"nome"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //pessoa imagem
    onPostImage(object: PessoaImagem, done: any) {
        this._restService.onPost(pessoaImageApiName, object, done);
    }

    onPutImage(object: PessoaImagem, done: any) {
        this._restService.onPut(pessoaImageApiName, object, done);
    }

    onDeleteImage(objectId: number, done: any) {
        this._restService.onDelete(pessoaImageApiName, objectId, done);
    }

    onGetByPessoa(pessoaId: number, done: any) {
        let filter: any = {where:{pessoaId:pessoaId,ativo:true}};
        this._restService.onGetPost(pessoaImageApiName, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/shared/pessoa-api.service.ts
 **/